import { openMenu, closeMenu, open_menu_state } from '@/function/function.js'
import PaymentConfirmation from '@/components/caisse/manage-bons/confirm-payment'
import EditTauxAssurance from '@/components/caisse/manage-bons/edit-taux-assurance'
import TicketCaisse from '@/components/caisse/ticket-caisse'
import GroupTaxation from '@/components/caisse/choix-groupe-taxation'
import EnteteBonEtFacture from '@/components/en-tete-bon-facture'
import { cca_config } from '../../../../../CCA_ENV_CONF/env'
import store_stock from "@/store/mods/stock/produits"
import $ from 'jquery'

export default {
    name: 'paiement',
    components: {
        PaymentConfirmation, TicketCaisse, EditTauxAssurance,
        EnteteBonEtFacture, GroupTaxation
    },
    props: [],
    data() {
        return {
            vm_state: open_menu_state,
            info_is_loading: true,
            info_error_load: false,
            est_assure: false,

            all_checked: false,
            operations_to_pay: [],
            input_qty: [],
            consultation_data: {},

            error_message: "",
            pa_undifined_error_msg: "",
            warning_contrat_expire: "",
            warning_message: "",
            warning_exclusion: "",
            warning_taxation: "",
            warning_taxation_prestations: [],
            warning_prestations: [],
            warning_prestations_exclues: [],
            warning_prestations_rupture: [],
            warning_pa_undefined: [],
            can_pay_with_deposit: false,
            is_printable: false,
            can_pay: false,
            can_do_action: false,
            toggle_payment_state: 0,

            total_net_a_payer: 0,
            part_assureur: 0,
            etat_paiement: '',
            prestation_data: {
                data_type: '',
                libelle: 'Paiement facture'
            },
            info_assurance: {},
            taux_couverture: '',
            index_group_prestation: 0,
            taux_toggler: 0,

            depot_data: {},
            prestations: [],
            compte_id: 0,
            filename: '',
            tmp_bill_date: '',
            water_mark_text: '',

            aib_liste: [
                {
                    libelle: 'N/A',
                    taux: 0,
                    slug: 'n_a'
                }
            ],
            selected_aib: {
                libelle: 'N/A',
                taux: 0,
                slug: 'n_a'
            },

            groupes_taxation: [],
            type_factures: [],
            taxation_data: {},
            taxation_togller: 0,

            ventilation_impots: [],
            recap_ventilation_impots: {},
            sfe_data: {},

            total_taxe_specifique: 0,
            total_imposable_aib: 0,
            impot_aib: 0,
            current_taxation: {},
            can_show_groupe_for_prestation: false,
            tot_base_assurance: 0,
            total_prix_assure: 0,
            total_prix_assureur: 0,
            is_reloading_tarif: false,
            checkbox_loading: true,

            chosen_patient: {},
            can_print: false,
            printing_operations: [],
            proforma_operations: [],
            liste_articles: [],
            prix_apport_social: 0,

            colspans: {
                colspan_1: '',
                colspan_2: '',
                colspan_3: '',
                colspan_4: '',
                colspan_5: '',
                colspan_6: '',
                colspan_7: '',
                colspan_8: '',
                print_colspan_1: '',
                print_colspan_2: '',
                print_colspan_3: '',
                print_colspan_4: '',
            },
            info_caissier: {}
        }
    },

    watch: {
        operations_to_pay() {
            this.warning_prestations_exclues = []
            this.warning_message = ""
            this.warning_exclusion = ""
            if (this.operations_to_pay.length == 0) {
                this.total_net_a_payer = 0
                this.can_do_action = false
                return;
            }

            this.can_do_action = true
            this.calculateBill()
            this.setPrestationToBePaid()

            this.refetch()
        },

        selected_aib() {
            if (Object.prototype.hasOwnProperty.call(this.current_taxation, 'group_taxation')) {
                this.handleVentilationCalculation(this.current_taxation)
                this.calculateBill()
            }
        }
    },

    computed: {
        userCredentials() {
            return this.$store.getters['authInfo'];
        },

        activeRole() {
            return this.$store.getters['activeRole'];
        },

        etat_ouverture_caisse() {
            return this.$store.getters['etat_ouverture_caisse'];
        },

        bill_selected_operations() {
            return this.$store.getters['bill_selected_operations']
        },

        paying_bill_state() {
            return this.$store.getters['paying_bill_state']
        },

        is_paid() {
            return this.$store.getters['is_paid']
        },

        patient() {
            return this.$store.getters['patient']
        },

        patient_insurance_info() {
            return this.$store.getters['patient_insurance_info']
        },

        depot_patient() {
            return this.$store.getters['depot_patient'];
        },

        can_add_differential_computing() {
            return this.$store.getters["can_add_differential_computing"]
        },

        sfe_liste_aib() {
            return this.$store.getters['sfe_liste_aib'];
        },

        sfe_groupes_taxation() {
            return this.$store.getters['sfe_groupes_taxation'];
        },

        is_vente_from_caisse() {
            return this.$store.getters['is_vente_from_caisse']
        },

        divers_info() {
            return this.$store.getters["divers_info"];
        },
    },  

    mounted() {
        this.selectListArticles()
        if (this.has_two_currencies) {
            this.$store.dispatch('getConfigInfoClinique', 'currency').then(() => {
                this.currency_info = this.$store.getters['info_currency']
            })
        }
        
        if (this.activeRole.nom == 'ROLE_CAISSIERE') {
            this.compte_id = 1 //  Caisse principale
        } else if (this.activeRole.nom == 'ROLE_CAISSIERE_INTERMITENT') {
            this.compte_id = 4 //  Caisse 1 (Infirmier)
        } else if (this.activeRole.nom == 'ROLE_COMPTABLE') {
            this.compte_id = 3 //  Comptabilité
        }

        this.info_caissier = {
            nom_caissier: this.userCredentials.user.name,
            titre: this.userCredentials.user.titre
        }

        this.checkRegisterCashStatus(this.compte_id)        // Function defined in util-mixins.js

        this.getInsuranceInfo()
        this.getDiversInfo()

        const ts = this;
        $(document).bind("click", function (e) {
            const $clicked = $(e.target);
            if (!$clicked.parents().hasClass("option-container")) {
                if (ts.vm_state != 0) {
                    ts.openMenu(ts.vm_state, 'option-box', 'animate-zoomIn', 'animate-zoomOut')
                }
            }
        });

        // Check if Differential computing should be applied
        this.$store.dispatch('getDifferentialComputing')

        this.patient.id = this.patient.patient_id

        // Check depot patient
        this.checkDepotPatient()

        const tmpstamp = this.current_date.getTime()
        this.filename = 'Facture_'+this.patient.nom_patient+'_'+tmpstamp

        this.setWaterMarkText()

        if (cca_config.IS_SFE) {
            // AIB SFE
            this.getListeAibSFE()

            
            this.initVentilationImpot()
        }

        

        Array.prototype.groupBy = function (key) {
            return this
                .reduce((hash, obj) => {
                    if (obj[key] === undefined) return hash;
                    return Object.assign(hash, { [obj[key]]: (hash[obj[key]] || []).concat(obj) })
                }, {})
        };
    },

    methods: {
        getDiversInfo() {
            this.$store.dispatch('getConfigInfoClinique', 'divers_info')
        },
        
        setColspans() {
            if (cca_config.IS_SFE) {
                if (this.can_set_pac) {
                    this.colspans.colspan_1 = 15
                    this.colspans.colspan_2 = 14

                    this.colspans.colspan_5 = 14
                    this.colspans.colspan_6 = 13

                    this.colspans.print_colspan_1 = 13
                    this.colspans.print_colspan_2 = 12
                } else {
                    this.colspans.colspan_1 = 13
                    this.colspans.colspan_2 = 12

                    this.colspans.colspan_5 = 12
                    this.colspans.colspan_6 = 11

                    this.colspans.print_colspan_1 = 12
                    this.colspans.print_colspan_2 = 11
                }
            } else {
                if (this.can_set_pac) {
                    this.colspans.colspan_3 = 13
                    this.colspans.colspan_4 = 12

                    this.colspans.colspan_7 = 12
                    this.colspans.colspan_8 = 11

                    this.colspans.print_colspan_3 = 12
                    this.colspans.print_colspan_4 = 11
                } else {
                    this.colspans.colspan_3 = 11
                    this.colspans.colspan_4 = 10

                    this.colspans.colspan_7 = 10
                    this.colspans.colspan_8 = 9

                    this.colspans.print_colspan_3 = 11
                    this.colspans.print_colspan_4 = 10
                }
            }
        },

        selectListArticles() {
            store_stock.getListeArticles().then((articles) => {
                this.liste_articles = articles

                this.checkPrestattions()
            })
        },

        checkPrestattions() {
            setTimeout(() => {
                let checker = document.getElementById("check-all")

                if (checker) {
                    checker.checked = true
                    this.checkAll()
                }
            }, 1000);
        },

        /**
         * Open Menu Dropdown
         */
        openMenu(state, selector, show_in, show_out) {
            this.vm_state = openMenu.dropMenu(state, selector, show_in, show_out)
        },

        /**
         * Close Menu Dropdown
         */
        closeMenu(selector, show_in, show_out) {
            this.vm_state = closeMenu.wrapMenu(selector, show_in, show_out)
        },

        setWaterMarkText() {
            switch (this.paying_bill_state) {
                case 0:
                    this.water_mark_text = "OPERATION EN ATTENTE"
                    break;
                case 1:
                    this.water_mark_text = "DUPLICATA"
                    break;
                case 2:
                    this.water_mark_text = "OPERATION DIFFÉRÉE"
                    break;
                case 3:
                    this.water_mark_text = "RESTE À PAYER"
                    break;
            }
        },

        checkDepotPatient() {
            // Depot patient
            this.$store.dispatch('getDepotPatient', this.patient.patient_id).then(() => {
                if (this.depot_patient.length == 0) {
                    this.can_pay_with_deposit = false
                } else {
                    this.can_pay_with_deposit = true
                }
            })
        },

        getInsuranceInfo() {
            this.info_is_loading = true
            this.$store.dispatch('getPatientInsuranceInfo', this.patient.patient_id).then(() => {
                if (!this.InsuranceIsValid(this.patient_insurance_info.contrat_a_expire)) {
                    this.warning_contrat_expire = "Le contrat d'assurrance de ce patient est expiré. En continuant, le patient sera traité comme un patient non assuré."
                }

                this.info_assurance = {
                    taux_couverture: '',
                    est_assure: this.patient_insurance_info.est_assure,
                    est_expire: this.patient_insurance_info.contrat_a_expire,
                    assurance_id: (this.patient_insurance_info.assur_id != null)?this.patient_insurance_info.assur_id:'',
                    assurance: this.patient_insurance_info.assur_nom,
                    souscripteur_id: (this.patient_insurance_info.souscripteur_id != null)?this.patient_insurance_info.souscripteur_id:'',
                    souscripteur: (this.patient_insurance_info.souscripteur != null)?this.patient_insurance_info.souscripteur:'',
                    assure_principal_id: (this.patient_insurance_info.assure_principal_id != null)?this.patient_insurance_info.assure_principal_id:'',
                }

                this.info_is_loading = false

                // document.getElementById("check-all").checked = true;
                this.checkPrestattions()

                this.setColspans()
            }).catch(() => {
                this.info_error_load = true
                this.info_is_loading = false
            })
        },

        setTauxToEdit(taux_couverture, index) {
            this.taux_toggler = (this.taux_toggler == 0)?1:0
            this.taux_couverture = taux_couverture
            this.index_group_prestation = index

            $('.edit-taux-assur').modal('show')
        },

        initPrix() {
            this.part_assure = 0
            this.part_assureur = 0
            this.tot_base_assurance = 0
        },

        calculatePartAssureur(param_assure) {
            let part_assureur = 0
            let total_pac =  param_assure.prix_assure_clinique * param_assure.qte
            let tmp_part_assureur = 0
            if (param_assure.base_assurance > 0 && this.paying_bill_state != 3) {
                tmp_part_assureur = parseInt( (param_assure.taux_couverture * param_assure.base_assurance * param_assure.qte) / 100) 
            }
            
            if (this.can_set_pac) {
                if (total_pac <= tmp_part_assureur) {
                    part_assureur = total_pac
                } else {
                    part_assureur = tmp_part_assureur
                }
            } else {
                part_assureur = tmp_part_assureur
            }
            
            return part_assureur;
        },

        calculatePartAssure(param_assure) {
            let part_assure = 0
            if (param_assure.est_exclu == 0 && param_assure.base_assurance >= 0) {
                if (this.can_set_pac && param_assure.prix_assure_clinique < param_assure.base_assurance) {
                    let tmp_part_assureur = 0
                    if (param_assure.base_assurance > 0) {
                        tmp_part_assureur = parseInt( (param_assure.taux_couverture * param_assure.base_assurance * param_assure.qte) / 100)
                    }

                    if (param_assure.prix_assure_clinique < param_assure.base_assurance) {
                        let total_pac = 0
                        if (param_assure.prix_assure_clinique > 0) {
                            total_pac =  param_assure.prix_assure_clinique * param_assure.qte

                            if (total_pac <= tmp_part_assureur) {
                                part_assure = 0
                            } else {
                                part_assure = total_pac - tmp_part_assureur
                            }
                        }
                    }
                } else {
                    if (this.can_add_differential_computing.response == "Oui") {
                        let pac = 0
                        if (this.can_set_pac) {
                            pac = (param_assure.prix_assure_clinique === '')?0:param_assure.prix_assure_clinique
                        } else {
                            pac = param_assure.pu
                        }

                        const prix_additionnel = (pac > param_assure.base_assurance)?(pac - param_assure.base_assurance):0
                        part_assure = Math.ceil( ( ( (100 - param_assure.taux_couverture) / 100 ) * param_assure.base_assurance ) +
                            +  parseInt(prix_additionnel) ) * param_assure.qte
                    } else {
                        part_assure = ( Math.ceil( ( (100 - param_assure.taux_couverture) / 100 ) * param_assure.base_assurance ) * param_assure.qte)
                    }
                }
            } else {
                // if (this.can_set_pac && this.patient_insurance_info.est_assure) {
                //     part_assure = 0
                // } else {
                //     part_assure = param_assure.qte * param_assure.pu
                // }
                part_assure = param_assure.qte * param_assure.pu
            }
            return part_assure;
        },

        refreshTarification(taux) {
            this.is_reloading_tarif = true

            this.bill_selected_operations[this.index_group_prestation].taux_assurance = taux

            let j = 0
            this.bill_selected_operations[this.index_group_prestation].prestations.forEach(prestation => {
                let base_assurance = this.bill_selected_operations[this.index_group_prestation].prestations[j].tmp_base_assurance
                const prix_assure_clinique = this.bill_selected_operations[this.index_group_prestation].prestations[j].tmp_prix_assure_clinique
                const quantite = this.bill_selected_operations[this.index_group_prestation].prestations[j].tmp_qte
                const prix_unitaire = this.bill_selected_operations[this.index_group_prestation].prestations[j].prix_unitaire
                let montant_du = 0

                const base_is_empty = this.validateStringNotEmpty(base_assurance)
                if (base_is_empty) {
                    this.warningToast("La base assurance de \""+prestation.libelle+"\" n'est pas défini")
                    // return;
                }

                // base_assurance = this.cleanNumber(base_assurance)
                // const is_greater_zero = this.checkIfNumberGreaterThanZero(base_assurance)
                // if (!is_greater_zero) {
                //     this.warningToast("La base assurance de \""+prestation.libelle+"\" doit être supérieure à zéro")
                //     // return;
                // }

                const est_exclu = this.bill_selected_operations[this.index_group_prestation].prestations[j].est_exclu
                const param_assure = {
                    base_assurance: base_assurance,
                    prix_assure_clinique: prix_assure_clinique,
                    taux_couverture: taux,
                    pu: prix_unitaire,
                    qte: quantite,
                    est_exclu: est_exclu
                }

                this.bill_selected_operations[this.index_group_prestation].prestations[j].taux_assurance = taux
                this.bill_selected_operations[this.index_group_prestation].prestations[j].tmp_taux_assurance = taux
                this.bill_selected_operations[this.index_group_prestation].prestations[j].part_assureur = this.calculatePartAssureur(param_assure)

                montant_du = this.calculatePartAssure(param_assure)

                this.bill_selected_operations[this.index_group_prestation].prestations[j].montant_du = montant_du
                this.bill_selected_operations[this.index_group_prestation].prestations[j].montant_net_a_solder = montant_du
                this.bill_selected_operations[this.index_group_prestation].prestations[j].montant_restant = montant_du

                if (this.is_sfe) {
                    const info_taxation = {
                        group_taxation: this.bill_selected_operations[this.index_group_prestation].prestations[j].group_taxation,
                        prestation: this.bill_selected_operations[this.index_group_prestation].prestations[j].libelle,
                        taxe_specifique: this.bill_selected_operations[this.index_group_prestation].prestations[j].taxe_specifique,
                        prix: this.bill_selected_operations[this.index_group_prestation].prestations[j].montant_net_a_solder,
                        qte: this.bill_selected_operations[this.index_group_prestation].prestations[j].tmp_qte,
                        uid: this.bill_selected_operations[this.index_group_prestation].prestations[j].uid
                    }
                    this.updateGroupTaxation(info_taxation)
                }

                j++
            }); 
            this.$store.commit("SET_BILL_SELECTED_OPERATIONS", this.bill_selected_operations);

            if (this.operations_to_pay.length > 0) {
                this.calculateBill()
                this.setPrestationToBePaid()
            }
        },

        checkAll() {
            let is_checked = $('#check-all').is(":checked")

            if (is_checked) {
                this.operations_to_pay = []

                this.bill_selected_operations.forEach((operation, g_index) => {
                    operation.prestations.forEach((prestation, p_index) => {
                        this.operations_to_pay.push(prestation)

                        if (this.is_sfe) {
                            const tmp_group_taxation = this.groupes_taxation[0]
                        
                            this.bill_selected_operations[g_index].prestations[p_index].group_taxation = tmp_group_taxation
                            this.bill_selected_operations[g_index].prestations[p_index].slug_taxation = tmp_group_taxation.slug.toUpperCase()
                            this.bill_selected_operations[g_index].prestations[p_index].taxe_specifique = ""

                            const info_taxation = {
                                group_taxation: tmp_group_taxation,
                                prestation: this.bill_selected_operations[g_index].prestations[p_index].libelle,
                                taxe_specifique: this.bill_selected_operations[g_index].prestations[p_index].taxe_specifique,
                                prix: this.bill_selected_operations[g_index].prestations[p_index].montant_net_a_solder,
                                qte: this.bill_selected_operations[g_index].prestations[p_index].tmp_qte,
                                uid: this.bill_selected_operations[g_index].prestations[p_index].uid
                            }
                            this.updateGroupTaxation(info_taxation)
                        }
                    });
                    
                });
                this.all_checked = true
                
            } else {
                this.operations_to_pay = []
                this.warning_prestations_exclues = []
                this.warning_message = ""
                this.warning_exclusion = ""
                this.all_checked = false

                if (this.is_sfe) {
                    let tmp_info_group_taxation = {
                        libelle: "",
                        slug: "",
                        taux: ""
                    }

                    this.bill_selected_operations.forEach((operation, g_index) => {
                        let p_index = 0
                        operation.prestations.forEach(() => {
                            this.bill_selected_operations[g_index].prestations[p_index].group_taxation = ""
                            this.bill_selected_operations[g_index].prestations[p_index].slug_taxation = ""
                            this.bill_selected_operations[g_index].prestations[p_index].taxe_specifique = ""
    
                            const info_taxation = {
                                group_taxation: tmp_info_group_taxation,
                                prestation: this.bill_selected_operations[g_index].prestations[p_index].libelle,
                                taxe_specifique: this.bill_selected_operations[g_index].prestations[p_index].taxe_specifique,
                                prix: this.bill_selected_operations[g_index].prestations[p_index].montant_net_a_solder,
                                qte: this.bill_selected_operations[g_index].prestations[p_index].tmp_qte,
                                uid: this.bill_selected_operations[g_index].prestations[p_index].uid
                            }
                            this.updateGroupTaxation(info_taxation)
    
                            p_index++
                        });
                    });
                }
            }
        },

        onOneChange(g_index, p_index, operation_id) {
            document.getElementById("check-all").checked = false;

            if (this.is_sfe) {
                let tmp_group_taxation = this.groupes_taxation[0]
                let checked_state = document.getElementById('op-'+operation_id).checked
                let tmp_info_group_taxation = {
                    libelle: "",
                    slug: "",
                    taux: ""
                }

                if (!checked_state) {
                    this.bill_selected_operations[g_index].prestations[p_index].group_taxation = ""
                    this.bill_selected_operations[g_index].prestations[p_index].slug_taxation = ""
                    this.bill_selected_operations[g_index].prestations[p_index].taxe_specifique = ""
                } else {
                    this.bill_selected_operations[g_index].prestations[p_index].group_taxation = tmp_group_taxation
                    this.bill_selected_operations[g_index].prestations[p_index].slug_taxation = tmp_group_taxation.slug.toUpperCase()
                    this.bill_selected_operations[g_index].prestations[p_index].taxe_specifique = ""

                    tmp_info_group_taxation = tmp_group_taxation
                }
                
                const info_taxation = {
                    group_taxation: tmp_info_group_taxation,
                    prestation: this.bill_selected_operations[g_index].prestations[p_index].libelle,
                    taxe_specifique: this.bill_selected_operations[g_index].prestations[p_index].taxe_specifique,
                    prix: this.bill_selected_operations[g_index].prestations[p_index].montant_net_a_solder,
                    qte: this.bill_selected_operations[g_index].prestations[p_index].tmp_qte,
                    uid: this.bill_selected_operations[g_index].prestations[p_index].uid
                }
                this.updateGroupTaxation(info_taxation)
            }
        },

        handleBaseAssuranceChange(g_index, p_index, is_base_assur) {
            const qty = this.bill_selected_operations[g_index].prestations[p_index].tmp_qte
            const prix_unitaire = this.bill_selected_operations[g_index].prestations[p_index].prix_unitaire
            const rate = this.bill_selected_operations[g_index].prestations[p_index].tmp_taux_assurance;
            let prix_assure_clinique = ''
            let base_assurance = ''

            if (is_base_assur) {    // Modification de la base assurance
                prix_assure_clinique = this.bill_selected_operations[g_index].prestations[p_index].tmp_prix_assure_clinique

                const input_base = document.getElementById('bs-'+g_index+''+p_index)
                if (!input_base) {
                    return;
                }

                base_assurance = input_base.value

                const base_assur_is_empty = this.validateStringNotEmpty(base_assurance)
                if (!base_assur_is_empty) {
                    base_assurance = this.transformToNumber(base_assurance)
                } else {
                    base_assurance = 0
                }
            } else {  // Modification du Prix Assuré Clinique
                base_assurance = this.bill_selected_operations[g_index].prestations[p_index].tmp_base_assurance

                const input_pac = document.getElementById('pac-'+g_index+''+p_index)
                if (!input_pac) {
                    return;
                }
                
                prix_assure_clinique = input_pac.value

                const pac_is_empty = this.validateStringNotEmpty(prix_assure_clinique)
                if (!pac_is_empty) {
                    prix_assure_clinique = this.transformToNumber(prix_assure_clinique)
                } else {
                    prix_assure_clinique = 0
                }
            }
            
            this.bill_selected_operations[g_index].prestations[p_index].tmp_prix_assure_clinique = prix_assure_clinique
            this.bill_selected_operations[g_index].prestations[p_index].tmp_base_assurance = base_assurance

            // Calcul montant a payer
            let montant_a_payer = 0
            if (this.patient_insurance_info.est_assure && this.bill_selected_operations[g_index].prestations[p_index].can_apply_insurance_rate) {
                const est_exclu = this.bill_selected_operations[g_index].prestations[p_index].est_exclu

                const param_assure = {
                    base_assurance: base_assurance,
                    prix_assure_clinique: prix_assure_clinique,
                    taux_couverture: rate,
                    pu: prix_unitaire,
                    qte: qty,
                    est_exclu: est_exclu
                }

                montant_a_payer = this.calculatePartAssure(param_assure)
                this.bill_selected_operations[g_index].prestations[p_index].part_assureur = this.calculatePartAssureur(param_assure)
            } else {
                montant_a_payer = prix_unitaire * qty
            }

            // Appliquer taxe specifique s'il y a lieu
            let valeur_ajoutee = 0
            if (this.is_sfe) {
                const taxe_specifique = this.bill_selected_operations[g_index].prestations[p_index].taxe_specifique
                const taux = this.bill_selected_operations[g_index].prestations[p_index].group_taxation.taux

                if (taxe_specifique > 0) {
                    valeur_ajoutee = parseFloat( taxe_specifique * (1 + (taux / 100)) ).toFixed(0)
                    valeur_ajoutee = parseInt(valeur_ajoutee) 
                }
            } 

            this.bill_selected_operations[g_index].prestations[p_index]['prix_clinique_net'] = ((montant_a_payer) + valeur_ajoutee) 
            this.bill_selected_operations[g_index].prestations[p_index]['montant_net_a_solder'] = this.bill_selected_operations[g_index].prestations[p_index]['prix_clinique_net']

            this.calculateBill()
            this.setPrestationToBePaid()

            if (this.is_sfe) {
                const info_taxation = {
                    group_taxation: this.bill_selected_operations[g_index].prestations[p_index].group_taxation,
                    prestation: this.bill_selected_operations[g_index].prestations[p_index].libelle,
                    taxe_specifique: this.bill_selected_operations[g_index].prestations[p_index].taxe_specifique,
                    prix: this.bill_selected_operations[g_index].prestations[p_index].montant_net_a_solder,
                    qte: this.bill_selected_operations[g_index].prestations[p_index].tmp_qte,
                    uid: this.bill_selected_operations[g_index].prestations[p_index].uid
                }
                this.updateGroupTaxation(info_taxation)
            }
        },

        handleRateChange(g_index, p_index) {
            const qty = this.bill_selected_operations[g_index].prestations[p_index].tmp_qte
            const base_assurance = this.bill_selected_operations[g_index].prestations[p_index].tmp_base_assurance
            const prix_unitaire = this.bill_selected_operations[g_index].prestations[p_index].prix_unitaire
            const initial_rate = this.bill_selected_operations[g_index].prestations[p_index].taux_assurance;
            const prix_assure_clinique = this.bill_selected_operations[g_index].prestations[p_index].tmp_prix_assure_clinique

            // Get entry rate
            const input_rate = document.getElementById('tx-'+g_index+''+p_index)
            if (!input_rate) {
                return;
            }

            let rate = input_rate.value
            // rate = this.cleanNumber(rate)
            if (rate === '') {
                input_rate.value = 0
                this.calculateBill()
                this.setPrestationToBePaid()
                // return;
            }

            if (rate > 100) {
                this.warningToast('Merci de saisir un taux inferieur ou égale à 100 !')
                input_rate.value = initial_rate
                return;
            }

            if (rate < 0) {
                this.warningToast('Merci de saisir un taux supérieur ou égale à 0 !')
                input_rate.value = initial_rate
                return;
            }
            

            // Calcul montant a payer
            let montant_a_payer = 0
            if (this.patient_insurance_info.est_assure && this.bill_selected_operations[g_index].prestations[p_index].can_apply_insurance_rate) {
                const est_exclu = this.bill_selected_operations[g_index].prestations[p_index].est_exclu

                const param_assure = {
                    base_assurance: base_assurance,
                    prix_assure_clinique: prix_assure_clinique,
                    taux_couverture: rate,
                    pu: prix_unitaire,
                    qte: qty,
                    est_exclu: est_exclu
                }
                montant_a_payer = this.calculatePartAssure(param_assure)
                this.bill_selected_operations[g_index].prestations[p_index].part_assureur = this.calculatePartAssureur(param_assure)
            } else {
                montant_a_payer = prix_unitaire * qty
            }

            this.bill_selected_operations[g_index].prestations[p_index].tmp_taux_assurance = rate

            // // // Appliquer taxe specifique s'il y a lieu
            let valeur_ajoutee = 0
            if (this.is_sfe) {
                const taxe_specifique = this.bill_selected_operations[g_index].prestations[p_index].taxe_specifique
                const taux = this.bill_selected_operations[g_index].prestations[p_index].group_taxation.taux

                if (taxe_specifique > 0) {
                    valeur_ajoutee = parseFloat( taxe_specifique * (1 + (taux / 100)) ).toFixed(0)
                    valeur_ajoutee = parseInt(valeur_ajoutee) 
                }
            }  
            
            this.bill_selected_operations[g_index].prestations[p_index]['prix_clinique_net'] = ((montant_a_payer) + valeur_ajoutee) 
            this.bill_selected_operations[g_index].prestations[p_index]['montant_net_a_solder'] = this.bill_selected_operations[g_index].prestations[p_index]['prix_clinique_net']

            this.calculateBill()
            this.setPrestationToBePaid()

            if (this.is_sfe) {
                const info_taxation = {
                    group_taxation: this.bill_selected_operations[g_index].prestations[p_index].group_taxation,
                    prestation: this.bill_selected_operations[g_index].prestations[p_index].libelle,
                    taxe_specifique: this.bill_selected_operations[g_index].prestations[p_index].taxe_specifique,
                    prix: this.bill_selected_operations[g_index].prestations[p_index].montant_net_a_solder,
                    qte: this.bill_selected_operations[g_index].prestations[p_index].tmp_qte,
                    uid: this.bill_selected_operations[g_index].prestations[p_index].uid
                }
                this.updateGroupTaxation(info_taxation)
            }
        },

        refetch() {
            setTimeout(() => {
                for (let ix = 0; ix < this.bill_selected_operations.length; ix++) {
                    for (let jx = 0;  jx < this.bill_selected_operations[ix].prestations.length; jx++) {
                        this.handleQtyChange(ix, jx)
                    }
                }
            }, 1000);
        },

        handleQtyChange(g_index, p_index) {
            const initial_qty = this.bill_selected_operations[g_index].prestations[p_index].qte;
            let base_assurance = 0
            let taux_couverture = 0
            const prix_unitaire = this.bill_selected_operations[g_index].prestations[p_index].prix_unitaire
            const prix_assure_clinique = this.bill_selected_operations[g_index].prestations[p_index].tmp_prix_assure_clinique

            const input_qty = document.getElementById('qty-'+g_index+''+p_index)
            if (!input_qty) {
                return;
            }

            let qty = input_qty.value
            qty = this.cleanNumber(qty)
            if (qty === '') {
                return;
            }

            const is_greater_zero = this.checkIfNumberGreaterThanZero(qty)
            if (!is_greater_zero) {
                this.warningToast('Merci de saisir une valeur supérieure à 0 !')
                input_qty.value = initial_qty
                // this.bill_selected_operations[g_index].prestations[p_index].montant_net_a_solder = (montant_net_initial)
                this.calculateBill()
                this.setPrestationToBePaid()
                return;
            }

            // if (qty > initial_qty) {
            //     this.warningToast('Impossible de définir une quantité supérieure à l\'initiale !')
            //     input_qty.value = initial_qty
            //     // this.bill_selected_operations[g_index].prestations[p_index].montant_net_a_solder = (montant_net_initial)
            //     this.calculateBill()
            //     this.setPrestationToBePaid()
            //     return;
            // }

            let montant_net_initial = 0
            if (this.patient_insurance_info.est_assure && this.bill_selected_operations[g_index].prestations[p_index].can_apply_insurance_rate) {
                base_assurance = this.bill_selected_operations[g_index].prestations[p_index].tmp_base_assurance
                taux_couverture = this.bill_selected_operations[g_index].prestations[p_index].tmp_taux_assurance

                const est_exclu = this.bill_selected_operations[g_index].prestations[p_index].est_exclu

                const param = {
                    base_assurance: base_assurance,
                    prix_assure_clinique: prix_assure_clinique,
                    taux_couverture: taux_couverture,
                    pu: prix_unitaire,
                    qte: initial_qty,
                    est_exclu: est_exclu
                }
                montant_net_initial = this.calculatePartAssure(param)
            } else {
                montant_net_initial = this.bill_selected_operations[g_index].prestations[p_index].prix_clinique_net
            }
            this.bill_selected_operations[g_index].prestations[p_index].montant_net_a_solder = (montant_net_initial)
            
            this.bill_selected_operations[g_index].prestations[p_index].tmp_qte = qty

            // Calcul montant a payer
            let montant_a_payer = 0
            if (this.patient_insurance_info.est_assure && this.bill_selected_operations[g_index].prestations[p_index].can_apply_insurance_rate) {
                const est_exclu = this.bill_selected_operations[g_index].prestations[p_index].est_exclu

                const param_assure = {
                    base_assurance: base_assurance,
                    prix_assure_clinique: prix_assure_clinique,
                    taux_couverture: taux_couverture,
                    pu: prix_unitaire,
                    qte: qty,
                    est_exclu: est_exclu
                }

                montant_a_payer = this.calculatePartAssure(param_assure)
                
                this.bill_selected_operations[g_index].prestations[p_index].part_assureur = this.calculatePartAssureur(param_assure)
            } else {
                montant_a_payer = prix_unitaire * qty
            }

            // Appliquer taxe specifique s'il y a lieu
            let valeur_ajoutee = 0
            if (this.is_sfe) {
                const taxe_specifique = this.bill_selected_operations[g_index].prestations[p_index].taxe_specifique
                const taux = this.bill_selected_operations[g_index].prestations[p_index].group_taxation.taux
                
                if (taxe_specifique > 0) {
                    valeur_ajoutee = parseFloat( taxe_specifique * (1 + (taux / 100)) ).toFixed(0)
                    valeur_ajoutee = parseInt(valeur_ajoutee) 
                }
            }
            
            this.bill_selected_operations[g_index].prestations[p_index]['prix_clinique_net'] = ((montant_a_payer) + valeur_ajoutee) 
            this.bill_selected_operations[g_index].prestations[p_index]['montant_net_a_solder'] = this.bill_selected_operations[g_index].prestations[p_index]['prix_clinique_net']

            this.calculateBill()
            this.setPrestationToBePaid()

            if (this.is_sfe) {
                const info_taxation = {
                    group_taxation: this.bill_selected_operations[g_index].prestations[p_index].group_taxation,
                    prestation: this.bill_selected_operations[g_index].prestations[p_index].libelle,
                    taxe_specifique: this.bill_selected_operations[g_index].prestations[p_index].taxe_specifique,
                    prix: this.bill_selected_operations[g_index].prestations[p_index].montant_net_a_solder,
                    qte: this.bill_selected_operations[g_index].prestations[p_index].tmp_qte,
                    uid: this.bill_selected_operations[g_index].prestations[p_index].uid
                }
                this.updateGroupTaxation(info_taxation)
            }
            
        }, 

        validatePayment() {
            this.warning_prestations = []
            this.warning_pa_undefined = []
            this.warning_prestations_exclues = []
            this.warning_prestations_rupture = []
            this.warning_message = ""
            this.warning_exclusion = ""
            this.error_message = ""
            let one_price_is_undefined = false
            let one_base_is_undefined = false
            let one_prix_assure_is_undefined = false
            let one_qty_rupture = false


            this.operations_to_pay.forEach(operation => {
                let montant = operation.prix_unitaire
                montant = this.cleanNumber(montant)

                if (montant === '') {
                    this.error_message = "Le prix d'une ou plusieurs prestations n'ont pas été définis !"
                    one_price_is_undefined = true
                    this.warning_prestations.push(
                        {
                            libelle: operation.libelle
                        }
                    )
                }

                if (one_price_is_undefined) {
                    return;
                }

                // Check Qty for type medicament & consommable
                
                
                if (operation.data_type == 'medicament' || operation.data_type == 'consommable') {
                    this.liste_articles.forEach(article => {
                        if (article.qte_disponible === "" || article.qte_disponible === null) {
                            article.qte_disponible = 0
                        }

                        if (
                            (operation.id == article.id) && 
                            (operation.tmp_qte > article.qte_disponible)
                        ) {
                            one_qty_rupture = true
                            this.warning_prestations_rupture.push(
                                {
                                    libelle: operation.libelle,
                                    qte_disponible: article.qte_disponible
                                }
                            ) 
                        }
                    });
                }

                if (operation.est_exclu == 1) {
                    this.warning_exclusion = "Une ou plusieurs prestations ont été exclues. En continuant, le patient paiera la totalité des prestations concernées"
                    this.warning_prestations_exclues.push(
                        {
                            libelle: operation.libelle
                        }
                    )
                }

                if (this.patient_insurance_info.est_assure === 1) {
                    let base_assurance = operation.tmp_base_assurance
                    let taux_assurance = operation.tmp_taux_assurance
                    let prix_assure_clinique = operation.tmp_prix_assure_clinique

                    // base_assurance = this.cleanNumber(base_assurance)
                    if ((base_assurance == null || taux_assurance == null) && operation.can_apply_insurance_rate && operation.est_exclu == 0) {
                        this.error_message = "La base assurance ou le taux d'une ou plusieurs prestations n'ont pas été définis"
                        one_base_is_undefined = true
                        this.warning_prestations.push(
                            {
                                libelle: operation.libelle
                            }
                        )
                    }

                    if (this.paying_bill_state != 0) {
                        one_base_is_undefined = false
                    }

                    // Check if is PA is set
                    if (this.can_set_pac && operation.est_exclu == 0 && prix_assure_clinique == null && operation.can_apply_insurance_rate) {
                        this.pa_undifined_error_msg = "Le prix assuré d'une ou plusieurs prestations n'a pas été défini"
                        one_prix_assure_is_undefined = true
                        this.warning_pa_undefined.push(
                            {
                                libelle: operation.libelle
                            }
                        )
                    } else {
                        if (prix_assure_clinique == 0) {
                            this.pa_undifined_error_msg = "Le prix assuré d'une ou plusieurs prestations est égale à 0. Merci de définir un prix supérieur à 0 !"
                            one_prix_assure_is_undefined = true
                            this.warning_pa_undefined.push(
                                {
                                    libelle: operation.libelle
                                }
                            )
                        }
                    }
                }
            });

            if (one_price_is_undefined || one_base_is_undefined || one_qty_rupture || one_prix_assure_is_undefined) {
                this.can_pay = false
                return;
            }
            this.can_pay = true
        },

        resetSelectedPrestationGroupTaxation() {

        },

        calculateBill() {
            this.validatePayment()

            this.total_net_a_payer = 0
            this.tot_base_assurance = 0
            this.total_prix_assure = 0
            this.total_prix_assureur = 0
            const impot_additionel = (this.impot_aib > 0)?this.impot_aib:0
            if (this.can_pay) {
                this.operations_to_pay.forEach(operation => {
                    let montant = (this.paying_bill_state == 3)?operation.montant_restant:operation.montant_net_a_solder
                    montant = this.cleanNumber(montant)

                    if (operation.data_type == 'apport_social') {
                        montant = -montant
                    }
    
                    this.total_net_a_payer += montant
                    if (operation.tmp_base_assurance > 0) {
                        this.tot_base_assurance += ( parseInt(operation.tmp_base_assurance) * operation.tmp_qte )
                    }
                    
                    this.total_prix_assureur += operation.part_assureur
                    
                });
                this.total_net_a_payer += impot_additionel
                this.total_prix_assure = this.total_net_a_payer
            }
            this.is_reloading_tarif = false
        },

        setPrestationToBePaid() {
            this.prestations = []
            this.operations_to_pay.forEach(operation => {
                const tmp_prestation = {
                    uid: operation.uid,
                    data_type: operation.data_type,
                    parent_id: operation.parent_id,
                    parent_libelle: (operation.chirurgie)?operation.chirurgie:null,
                    id: operation.id,
                    operation_id: (operation.operation_id)?operation.operation_id:null,
                    libelle: operation.libelle,
                    code_assurance_prod: (operation.code_assurance_prod)?operation.code_assurance_prod:"",
                    prix: operation.prix_unitaire,
                    prix_clinique: operation.prix_unitaire,
                    prix_vente: operation.montant_net_a_solder,
                    group_taxation: operation.group_taxation,
                    taxe_specifique: operation.taxe_specifique,
                    net_paye: 0,
                    prix_assure_clinique: operation.tmp_prix_assure_clinique,
                    base_assurance: (operation.tmp_base_assurance && operation.tmp_base_assurance != null)?operation.tmp_base_assurance:0,
                    part_assureur: operation.part_assureur,
                    taux_couverture: operation.tmp_taux_assurance,
                    coupon_remise: (operation.remise_accordee != '')?operation.remise_accordee:0,
                    qte: operation.tmp_qte,
                    est_exclu: operation.est_exclu,
                    is_vente_caisse: this.is_vente_from_caisse,
                    montant_restant: operation.montant_restant
                }
                this.prestations.push(tmp_prestation)
                
            });
        },

        payWithDeposit() {
            this.depot_data = {}
            if (this.etat_paiement == 'depot') {
                this.depot_data = this.depot_patient
            }
        },

        onPayment(etat_paiement) {
            this.etat_paiement = etat_paiement
            this.payWithDeposit()
            
            this.toggle_payment_state = (this.toggle_payment_state == 0)?1:0

            this.recap_ventilation_impots = this.ventilation_impots.filter((ventilation) => ventilation.can_show)
            this.sfe_data = {
                recap_ventilation_impots: this.recap_ventilation_impots,
                total_taxe_specifique: this.total_taxe_specifique,
                info_aib: this.selected_aib,
                impot_aib: this.impot_aib,
                total_imposable_aib: this.total_imposable_aib
            }
        },

        updatePrestation(data) {
            this.chosen_patient = {
                nom: this.patient.nom_patient,
                prenoms: "",
                age: this.patient.age,
                sexe: this.patient.sexe,
                telephone_mobile: this.patient.telephone_mobile
            }

            this.paiement_data = data.paiement
            this.ticket_caisse_info = data.ticket_info
            this.setToPrintable()

            this.$store.commit("SET_IS_PAID", true);
            this.$store.commit("SET_PAYING_BILL_STATE", '');

            // GROUPED PRESTATIONS ---------------------------------------
            const tmp_grouped_operations = data.prestations.groupBy('data_type')
            let grouped_operations = []
          
            
            let is_vente_caisse = 0
            for (const key in tmp_grouped_operations) {
                is_vente_caisse = tmp_grouped_operations[key][0].is_vente_caisse
                const tmp_group = {
                    data_type: key,
                    prestations: tmp_grouped_operations[key]
                }
                grouped_operations.push(tmp_group)
            }
            
            // ------------------------------------------------------------

            this.updateOperations(data, grouped_operations, is_vente_caisse)
        },

        setToPrintable() {
            this.is_printable = true
        },

        updateOperations(paid_operations_data, grouped_operations, is_vente_caisse) {
            // Si produit est un médicament ou consommable alors enregistrer vente stock
            let tmp_articles_stock = grouped_operations.filter(
                operation => operation.data_type == 'medicament' || operation.data_type == 'consommable'
            )
            let articles_stock = []
            tmp_articles_stock.forEach(article => {
                article.prestations.forEach(prestation => {
                    articles_stock.push(prestation)
                });
            });
            
            this.sendVentePharmacie(articles_stock)
            
            if (is_vente_caisse == 1 && paid_operations_data.paiement.paying_bill_state == 0) {
                this.saveBonExamen(paid_operations_data, grouped_operations)
                this.saveBonAnalyse(paid_operations_data, grouped_operations)
            }
            
            grouped_operations.forEach(operation => {
                let data = this.setDataToUpdate(operation)

                const update_data = {
                    prestations: data.prestations,
                    etat_paiement: paid_operations_data.etat_paiement
                }
                
                this.$store.dispatch(data.dispatch_action, update_data)
            });

        },

        sendVentePharmacie(articles) {
            
            const vente_data = {
                articles: articles,
                patient: this.patient.nom_patient,
                prescripteur: "interne"
            }

            this.$store.dispatch('storeVente', vente_data)
        },

        setDataToUpdate(operation) {
            let dispatch_action = ''
            let prestations = []
            
            switch (operation.data_type) {
                case 'analyse':
                    dispatch_action = 'setPaidDemandeAnalyse'
                    prestations = operation.prestations
                    break;
                case 'examen':
                    dispatch_action = 'setPaidDemandeExamen'
                    prestations = operation.prestations
                    break;
                case 'medicament':
                    dispatch_action = 'setPaidPharmacieArticle'
                    prestations = operation.prestations
                    break;
                case 'consommable':
                    dispatch_action = 'setPaidPharmacieArticle'
                    prestations = operation.prestations
                    break;
                case 'acte':
                    dispatch_action = 'setPaidProtocoleConstitution'
                    prestations = operation.prestations
                    break;
                case 'chambre':
                    dispatch_action = 'setPaidProtocoleConstitution'
                    prestations = operation.prestations
                    break;
                case 'observation':
                    dispatch_action = 'setPaidProtocoleConstitution'
                    prestations = operation.prestations
                    break;
                case 'admission':
                    dispatch_action = 'setPaidProtocoleConstitution'
                    prestations = operation.prestations
                    break;
            }

            let data = {
                dispatch_action: dispatch_action,
                prestations: prestations
            }
            return data
        },

        printTmpBill() {
            this.proforma_operations = []
            this.printing_operations = []
            
            Array.prototype.groupBy = function (key) {
                return this
                    .reduce((hash, obj) => {
                        if (obj[key] === undefined) return hash;
                        return Object.assign(hash, { [obj[key]]: (hash[obj[key]] || []).concat(obj) })
                    }, {})
            };

            const tmp_grouped_operations = this.operations_to_pay.groupBy('data_type')
           

            for (const key in tmp_grouped_operations) {

                if (key == 'chirurgie') {
                    const tmp_grouped_prestations = tmp_grouped_operations[key].groupBy('chirurgie')

                    for (const key_prest in tmp_grouped_prestations) {
                        const tmp_group = {
                            data_type: key,
                            group_prestation: tmp_grouped_operations[key][0].group_prestation,
                            prestations: tmp_grouped_prestations[key_prest],
                            chirurgie: key_prest,
                            taux_assurance: tmp_grouped_operations[key][0].taux_assurance,
                            aib: tmp_grouped_operations[key][0].aib
                        } 
                        this.proforma_operations.push(tmp_group) 
                    }
                } else {
                    const tmp_group = {
                        data_type: key,
                        group_prestation: tmp_grouped_operations[key][0].group_prestation,
                        prestations: tmp_grouped_operations[key],
                        taux_assurance: tmp_grouped_operations[key][0].taux_assurance,
                        aib: tmp_grouped_operations[key][0].aib
                    }
                    this.proforma_operations.push(tmp_group)
                }

                let tmp_prestation = { 
                    'slug': key, 
                    'libelle': tmp_grouped_operations[key][0].group_prestation
                }
                this.printing_operations.push(tmp_prestation)
            }


            this.can_print = true
            this.tmp_bill_date = new Date() 

            setTimeout(() => {
                window.print()
                this.can_print = false
            }, 500);
        },

        setGroupedTaxation(group, index) {
            const tmp_group_taxation = this.groupes_taxation[0]

            const grouped_libelle = (group == '')?'Tout':group.group_prestation
            const chirurgie = (group != '' && group.data_type == 'chirurgie')?' - '+group.chirurgie:''

            this.taxation_data = {
                data_type: (group != '' && group.data_type)?group.data_type:'',
                prestation: grouped_libelle+chirurgie,
                uid: "",
                group_taxation: tmp_group_taxation,
                taxe_specifique: "",
                prix: 0,
                qte: 0,
                is_grouped: true,
                index: index
            }

            this.taxation_togller = (this.taxation_togller == 0)?1:0
            $('.grp-taxation').modal('show')
        },

        fillGroupedTaxation(selected_group_taxation) {

            const index = selected_group_taxation.index
            this.bill_selected_operations[index].prestations.forEach((prestation, j) => {
                this.bill_selected_operations[index].prestations[j].group_taxation = selected_group_taxation.group_taxation
                this.bill_selected_operations[index].prestations[j].slug_taxation = selected_group_taxation.group_taxation.slug.toUpperCase()
                this.bill_selected_operations[index].prestations[j].taxe_specifique = selected_group_taxation.taxe_specifique
                

                let prix_prestation = (prestation.prix_unitaire > prestation.base_assurance)?prestation.prix_unitaire:prestation.base_assurance
                prix_prestation = prix_prestation * prestation.qte
                this.bill_selected_operations[index].prestations[j].prix_clinique_net = prix_prestation

                let montant_a_payer = this.bill_selected_operations[index].prestations[j].montant_net_a_solder

                const info_taxation = {
                    group_taxation: {
                        libelle: selected_group_taxation.group_taxation.libelle,
                        slug: selected_group_taxation.group_taxation.slug,
                        taux: selected_group_taxation.group_taxation.taux
                    },
                    prestation: prestation.libelle,
                    uid: prestation.uid,
                    taxe_specifique: prestation.taxe_specifique,
                    prix: montant_a_payer,
                    qte: prestation.tmp_qte
                }
                this.updateGroupTaxation(info_taxation)
            });
        },

        initPrestationsInfoSFE(tmp_group_taxation, taxe_specifique) {
            this.bill_selected_operations.forEach((operation, index) => {
                operation.prestations.forEach((prestation, j) => {
                    if (this.is_sfe) {
                        this.bill_selected_operations[index].prestations[j].group_taxation = tmp_group_taxation
                        this.bill_selected_operations[index].prestations[j].slug_taxation = tmp_group_taxation.slug.toUpperCase()
                        this.bill_selected_operations[index].prestations[j].taxe_specifique = taxe_specifique
                    } else {
                        this.bill_selected_operations[index].prestations[j].group_taxation = ""
                        this.bill_selected_operations[index].prestations[j].slug_taxation = ""
                        this.bill_selected_operations[index].prestations[j].taxe_specifique = ""
                    }
                    

                    let prix_prestation = (prestation.prix_unitaire > prestation.base_assurance)?prestation.prix_unitaire:prestation.base_assurance
                    prix_prestation = prix_prestation * prestation.qte
                    this.bill_selected_operations[index].prestations[j].prix_clinique_net = prix_prestation

                    let montant_a_payer = this.bill_selected_operations[index].prestations[j].montant_net_a_solder

                    const info_taxation = {
                        group_taxation: {
                            libelle: tmp_group_taxation.libelle,
                            slug: tmp_group_taxation.slug,
                            taux: tmp_group_taxation.taux
                        },
                        prestation: prestation.libelle,
                        uid: prestation.uid,
                        taxe_specifique: taxe_specifique,
                        prix: montant_a_payer,
                        qte: prestation.tmp_qte
                    }
                    this.updateGroupTaxation(info_taxation)
                });
            });
        },

        getGroupeTaxationSFE() {
            const data = {
                data_type: 'taxation_type',
                endpoint: 'taxGroups'
            }
            this.$store.dispatch('getInfoSFE', data).then(() => {
                const groupe_taxation = Object.keys(this.sfe_groupes_taxation);

                const taxation_items = ['a', 'b', 'c', 'd', 'e', 'f']
                groupe_taxation.forEach(key => {
                    if (taxation_items.includes(key)) {
                        const tmp_aib = {
                            libelle: this.setLibelleGroupTaxation(key),
                            taux: this.sfe_groupes_taxation[key],
                            slug: key
                        }
                        this.groupes_taxation.push(tmp_aib)
                    }
                });
                let tmp_group_taxation = this.groupes_taxation[0]
                this.initPrestationsInfoSFE(tmp_group_taxation, "")
            })
        },

        async initVentilationImpot() {
            const data = {
                data_type: 'taxation_type',
                endpoint: 'taxGroups'
            }
            await this.$store.dispatch('getInfoSFE', data).then(() => {
                const groupe_taxation = Object.keys(this.sfe_groupes_taxation);

                const taxation_items = ['a', 'b', 'c', 'd', 'e', 'f']
                groupe_taxation.forEach(key => {
                    if (taxation_items.includes(key)) {
                        const tmp_ventilation = {
                            libelle: this.setLibelleGroupTaxation(key),
                            taux: this.sfe_groupes_taxation[key],
                            impot: 0, 
                            imposable: 0,
                            total: 0,
                            can_show: false,
                            prestations: []
                        }
                        this.ventilation_impots.push(tmp_ventilation)
                    }
                });

                // Groupe taxation
                this.getGroupeTaxationSFE()
            })

            if (this.paying_bill_state !== 0) {
                this.getLibelleAIB(this.bill_selected_operations[0].aib)
            }
        },

        async getListeAibSFE() {
            const data = {
                data_type: 'taxation_type',
                endpoint: 'taxGroups'
            }
            await this.$store.dispatch('getInfoSFE', data).then(() => {

                const listes_aib = Object.keys(this.sfe_liste_aib);
                const aib_items = ['aibA', 'aibB']

                listes_aib.forEach(key => {
                    if (aib_items.includes(key)) {
                        const tmp_aib = {
                            libelle: this.setLibelleGroupTaxation(key),
                            taux: this.sfe_liste_aib[key],
                            slug: key
                        }
                        this.aib_liste.push(tmp_aib)
                    }
                });
            })
        },

        async getLibelleAIB(aib) {
            console.log(aib);

            await this.bill_selected_operations.forEach(operation => {
                operation.prestations.forEach(prestation => {
                    const info_taxation = {
                        group_taxation: {
                            libelle: this.setLibelleGroupTaxation(prestation.groupe_taxation.toLowerCase()),
                            slug: prestation.groupe_taxation.toLowerCase(),
                            taux: prestation.taux_taxation
                        },
                        prestation: prestation.libelle,
                        taxe_specifique: prestation.taxe_specifique,
                        prix: prestation.montant_net_a_solder,
                        qte: prestation.tmp_qte,
                        uid: prestation.uid
                    }
                    this.updateGroupTaxation(info_taxation)
                });
            });
        },

        setGroupTaxation(prestation) {
            const param_assure = {
                base_assurance: prestation.base_assurance,
                prix_assure_clinique: prestation.tmp_prix_assure_clinique,
                taux_couverture: prestation.tmp_taux_assurance,
                pu: prestation.prix_unitaire,
                qte: prestation.tmp_qte,
                est_exclu: prestation.est_exclu
            }
            let montant_a_payer = 0

            if (this.patient_insurance_info.est_assure) {
                montant_a_payer = this.calculatePartAssure(param_assure)
            } else {
                montant_a_payer = prestation.prix_unitaire * prestation.tmp_qte
            }
            

            this.taxation_data = {
                data_type: '',
                prestation: prestation.libelle,
                uid: prestation.uid,
                group_taxation: prestation.group_taxation,
                taxe_specifique: prestation.taxe_specifique,
                prix: montant_a_payer,
                qte: prestation.tmp_qte,
                is_grouped: false,
                index: 0
            }

            this.taxation_togller = (this.taxation_togller == 0)?1:0
        },

        setGroupTaxationToUpdate(data) {
            if (data.is_grouped) {
                if (data.index >= 0) {
                    this.fillGroupedTaxation(data)
                } else {
                    this.initPrestationsInfoSFE(data.group_taxation, data.taxe_specifique)
                }
            } else {
                this.updateGroupTaxation(data)
            }
        },

        async updateGroupTaxation(data) {
            let valeur_ajoutee = 0

            await this.bill_selected_operations.forEach((operation) => {
                operation.prestations.forEach((prestation, index) => {
                    if (prestation.uid == data.uid) {
                        operation.prestations[index].group_taxation = data.group_taxation
                        operation.prestations[index].taxe_specifique = data.taxe_specifique
                        operation.prestations[index].slug_taxation = this.capitalizeFirstLetter(data.group_taxation.slug)

                        // Calcul montant a payer
                        let montant_a_payer = 0
                        if (this.patient_insurance_info.est_assure && prestation.can_apply_insurance_rate) {
                            const est_exclu = prestation.est_exclu

                            const param_assure = {
                                base_assurance: prestation.tmp_base_assurance,
                                prix_assure_clinique: prestation.tmp_prix_assure_clinique,
                                taux_couverture: prestation.tmp_taux_assurance,
                                pu: prestation.prix_unitaire,
                                qte: prestation.tmp_qte,
                                est_exclu: est_exclu
                            }
                            montant_a_payer = this.calculatePartAssure(param_assure)
                        } else {
                            montant_a_payer = prestation.prix_unitaire * prestation.tmp_qte
                        }
    
                        if (data.taxe_specifique > 0) {
                            valeur_ajoutee = parseFloat( data.taxe_specifique * (1 + (data.group_taxation.taux / 100)) ).toFixed(0)
                            valeur_ajoutee = parseInt(valeur_ajoutee)
                        }
                        operation.prestations[index]['prix_clinique_net'] = (montant_a_payer + valeur_ajoutee) 
                        operation.prestations[index]['montant_net_a_solder'] = operation.prestations[index]['prix_clinique_net']
                    }
                });
            });
            await this.handleVentilationCalculation(data)
            await this.calculateBill()
            await this.setPrestationToBePaid()
        },

        resetValue(index) {
            this.ventilation_impots[index]['total'] = 0
            this.ventilation_impots[index]['imposable'] = 0
            this.ventilation_impots[index]['impot'] = 0
        },

        handleVentilationCalculation(taxation) {
            this.current_taxation = taxation
            this.total_taxe_specifique = 0
            this.total_imposable_aib = 0
            this.impot_aib = 0

            this.ventilation_impots.forEach((ventilation, index) => {
                if (ventilation.libelle == taxation.group_taxation.libelle) {
                    this.ventilation_impots[index]['can_show'] = true

                    let is_new = true

                    const tmp_ventilation_prestation = {
                        libelle: taxation.prestation,
                        uid: taxation.uid,
                        prix: taxation.prix,
                        taxe_specifique: taxation.taxe_specifique, 
                        taux: taxation.group_taxation.taux, 
                        qte: taxation.qte
                    }
                    this.ventilation_impots[index]['prestations'].forEach((prestation, j) => {
                        if (prestation.uid == taxation.uid) {
                            is_new = false
                            this.ventilation_impots[index]['prestations'][j]['taxe_specifique'] = taxation.taxe_specifique
                            this.ventilation_impots[index]['prestations'][j]['qte'] = taxation.qte
                        }
                    });

                    if (is_new) {
                        this.ventilation_impots[index]['prestations'].push(tmp_ventilation_prestation)
                    }
                } else {
                    this.ventilation_impots[index]['prestations'].forEach((prestation, pi) => {

                        if (prestation.uid == taxation.uid) {
                            
                            this.ventilation_impots[index]['prestations'].splice(pi, 1)
                        } 
                    });
                }

                this.resetValue(index)
                let sfe_tot = 0
                let sfe_impot = 0

                this.ventilation_impots[index]['prestations'].forEach((prestation, pi) => {
                    if (taxation.uid == prestation.uid) {
                        this.ventilation_impots[index]['prestations'][pi]['prix'] = taxation.prix
                        this.ventilation_impots[index]['prestations'][pi]['taxe_specifique'] = taxation.taxe_specifique
                    }

                    let valeur_ajoutee = 0
                    if (prestation.taxe_specifique > 0) {
                        valeur_ajoutee = parseFloat( prestation.taxe_specifique * (1 + (prestation.taux / 100)) ).toFixed(0)

                        this.total_taxe_specifique += prestation.taxe_specifique
                    }
                    valeur_ajoutee = parseInt(valeur_ajoutee)
                    // this.ventilation_impots[index]['total'] += ((prestation.prix * prestation.qte) + valeur_ajoutee)
                    this.ventilation_impots[index]['total'] += (prestation.prix + valeur_ajoutee)
                    sfe_tot = this.ventilation_impots[index]['total']

                    // Calcul imposable
                    if (prestation.taux > 0) {
                        this.ventilation_impots[index]['imposable'] = parseInt(this.ventilation_impots[index]['imposable'])
                        this.ventilation_impots[index]['imposable'] = ( this.ventilation_impots[index]['total'] / (1 + prestation.taux/100) )
                        this.ventilation_impots[index]['imposable'] = parseFloat(this.ventilation_impots[index]['imposable']).toFixed(0)
                        this.ventilation_impots[index]['imposable'] = parseInt(this.ventilation_impots[index]['imposable'])

                        // Calcul impot 
                        this.ventilation_impots[index]['impot'] = this.ventilation_impots[index]['total'] - this.ventilation_impots[index]['imposable'] 
                        sfe_impot = this.ventilation_impots[index]['impot'] 
                    }
                });

                // Calcul AIB
                if (this.selected_aib.libelle != 'N/A') {
                    this.total_imposable_aib += (sfe_tot - sfe_impot)
                }

                this.impot_aib = parseFloat((this.selected_aib.taux / 100) * this.total_imposable_aib).toFixed(0)
                this.impot_aib = parseInt(this.impot_aib)

                // Check if can show "Ventilation impôt" for prestation
                let tmp_can_show = false
                this.bill_selected_operations.forEach((operation) => {
                    operation.prestations.forEach(prestation => {
                        if (ventilation.libelle === prestation.group_taxation.libelle) {
                            tmp_can_show = true
                        }
                    });
                });

                // Eliminate not chosen group from ventilation impots
                if (!tmp_can_show) {
                    this.ventilation_impots[index]['can_show'] = false
                    this.resetValue(index)
                }
            });
            this.ventilation_impots.forEach(ventilation => {
                if (ventilation.can_show == true) {
                    this.can_show_groupe_for_prestation = true
                }
            });
        },

        checkChosenGroupTaxation(vm_state, down_option_box, animate_zoomIn, animate_zoomOut) {
            if (cca_config.IS_SFE) {
                this.warning_taxation_prestations = []

                this.operations_to_pay.forEach(prestation => {
                    if (prestation.group_taxation == "") {
                        this.warning_taxation_prestations.push(
                            {
                                libelle: prestation.libelle
                            }
                        )
                    }
                });

                if (this.warning_taxation_prestations.length > 0) {
                    this.warning_taxation = "Le groupe de taxation d'une ou plusieurs prestations n'a pas été défini !"
                    // this.can_pay = false
                }

                if (this.warning_taxation != "") {
                    return;
                }
            }
            this.openMenu(vm_state, down_option_box, animate_zoomIn, animate_zoomOut)
        },

        saveBonAnalyse(data, grouped_operations) {
            // Analyses
            let tmp_analyses = grouped_operations.filter(
                operation => operation.data_type == 'analyse'
            )

            if (tmp_analyses.length == 0) {
                return;
            }

            const analyse_data = {
                bulletin_id: 0,
                user_id: this.userCredentials.user.id,
                consultation_id: 0,
                evolution_id: 0,
                renseignement_clinique: '',
                choix_type_demande: 'interne', 
                analyses: tmp_analyses[0].prestations,
                etat_paiement: data.etat_paiement,
                patient_id: this.patient.patient_id,
                nom_patient: this.chosen_patient.nom,
                sexe: this.chosen_patient.sexe,
                telephone: this.chosen_patient.telephone_mobile,
                assurance: this.info_assurance.assurance,
                societe_souscripteur: this.info_assurance.souscripteur,
            }
            this.$store.dispatch('saveBulletinAnalyse', analyse_data)
        },

        saveBonExamen(data, grouped_operations) {
            // Examens
            let tmp_examens = grouped_operations.filter(
                operation => operation.data_type == 'examen'
            )

            if (tmp_examens.length == 0) {
                return;
            }

            const examen_data = {
                bulletin_id: 0,
                user_id: this.userCredentials.user.id,
                consultation_id: 0,
                evolution_id: 0,
                renseignement_clinique: '',
                choix_type_demande: 'interne', 
                examen_selectionnes: tmp_examens[0].prestations,
                etat_paiement: data.etat_paiement,
                patient_id: this.patient.patient_id,
                nom_patient: this.chosen_patient.nom,
                sexe: this.chosen_patient.sexe,
                telephone: this.chosen_patient.telephone_mobile,
                assurance: this.info_assurance.assurance,
                societe_souscripteur: this.info_assurance.souscripteur,
            }
            this.$store.dispatch('saveDemandeExamen', examen_data)
        },
    }
}